import { AlertCircle, Loader2, RotateCw } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useT } from "@/lib/i18n";
import { cn } from "@/lib/utils";

/** Sorgu hata durumu: mesaj + isteğe bağlı detay + "Tekrar dene". */
export function QueryError({
  message,
  detail,
  onRetry,
  retrying,
  className,
}: {
  message: string;
  detail?: string | null;
  onRetry?: () => void;
  retrying?: boolean;
  className?: string;
}) {
  const t = useT("common");
  return (
    <div
      role="alert"
      className={cn(
        "flex flex-col gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm sm:flex-row sm:items-center",
        className,
      )}
    >
      <AlertCircle className="h-5 w-5 shrink-0 text-destructive" />
      <div className="min-w-0 flex-1 space-y-0.5">
        <p className="font-medium text-destructive">{message}</p>
        {detail ? <p className="text-muted-foreground">{detail}</p> : null}
      </div>
      {onRetry ? (
        <Button
          size="sm"
          variant="outline"
          className="self-start sm:self-auto"
          disabled={retrying}
          onClick={onRetry}
        >
          {retrying ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <RotateCw className="h-4 w-4" />
          )}
          {t("retry")}
        </Button>
      ) : null}
    </div>
  );
}
